import { render, staticRenderFns } from "./DadosEstadoComplemento.vue?vue&type=template&id=0ec83b6e&"
import script from "./DadosEstadoComplemento.vue?vue&type=script&lang=ts&"
export * from "./DadosEstadoComplemento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
